import { Injectable, Inject } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { CacheService } from './cache.service';

@Injectable({
    providedIn: "root"
})
export class VersionService {

    constructor(private http: HttpClient, @Inject("environment") private environment: any, private cacheService: CacheService) { }

    className = 'VersionService';

    getAllVersions(cache = true, cacheKey = "allVersions"): any {
        if (this.cacheService.canUseCache(cacheKey) && cache) {
            return this.cacheService.getCacheData(cacheKey);
          } else {
            let observable = this.http.get(this.environment.base_URL + "/version").pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey)
            return {
                front: this.environment.version,
                ...res
            }
            }))
            this.cacheService.updateCacheReq(cacheKey);
            return observable;
          }
    }
}
